import UserSmallHeader from 'components/Headers/UserSmallHeader';

import { createContext, Key, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { PropostaVersao } from 'models/PropostaVersao';
import Proposta from 'models/Proposta';
import { PropostaVersaoParcelas } from 'models/PropostaVersaoParcelas';
import Orcamento from 'models/Orcamento';
import formatCurrency from 'utils/formatCurrency';
import api from 'services/api';
import { useQuery } from 'react-query';
import formataCnpjCpf from 'utils/formataCnpjCpf';
import { Col, Row } from 'reactstrap';
import FloatingButton from 'components/FloatingButton';
import { FaPrint } from 'react-icons/fa';
import { CircularProgress } from '@material-ui/core';
import config from 'config';
import { PropostaConfiguracao } from 'models/PropostaConfiguracao';

import { ProdutoProposta } from 'models/ProdutoProposta';
import FichaTecnica from 'models/FichaTecnica';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import { PropostaVersaoAvalista } from 'models/PropostaVersaoAvalista';
import LogoImg from '../assets/img/logo_fck.png';

interface LocationState {
  proposta: Proposta;
  propostaVersao: PropostaVersao;
  produtoProposta: ProdutoProposta;
}

interface PropostaImpressaoContext {
  proposta: Proposta;
  propostaVersao: PropostaVersao;
  isPropostaExterior: boolean;
  setIsPropostaExterior: (valor: boolean) => void;
  valorDolar: number;
  setValorDolar: (valor: number) => void;
  parcelas: PropostaVersaoParcelas[];
  orcamento: Orcamento;
}

export const PropostaImpressaoContext = createContext(
  {} as PropostaImpressaoContext,
);

interface iParamsLista {
  label: string;
  valor: any;
}

interface PapeisAta {
  codigo: any;
  id: number;
  papel: string;
  pessoa: string;
}

export default function PedidoVenda({
  valores,
  listaDadosProdutos,
}: {
  valores: iParamsLista[];
  listaDadosProdutos: [];
}): JSX.Element {
  const location = useLocation<LocationState>();
  const { proposta, propostaVersao, produtoProposta } = location.state;
  const [orcamento, setOrcamento] = useState({} as Orcamento);
  const [papeisAta, setPapeisAta] = useState([] as PapeisAta[]);
  const [avalista, setAvalista] = useState<PropostaVersaoAvalista>();
  const orcamentoId = propostaVersao?.PropostaConfiguracao?.[0]?.orcamentoId;
  async function getValorByLabel(nome: string) {
    return valores.find(item => item.label === `${nome}`)?.valor;
  }

  const meioPagamentoId = propostaVersao?.meioPagamentoId ?? 0;
  // S - N
  const possuiFabricanteNelson = valores.find(
    item => item.label === `possuiAspersorNelson`,
  )?.valor;

  const clienteNome = valores.find(item => item.label === `clienteNome`)?.valor;
  const tensao = valores.find(item => item.label === `resposta_tensao`)?.valor;
  const propostaValorFinal = valores.find(
    item => item.label === `propostaValorFinal`,
  )?.valor;
  const propostaValorFinalExtenso = valores.find(
    item => item.label === `propostaValorFinalExtenso`,
  )?.valor;
  const numeroProposta = valores.find(
    item => item.label === `numeroProposta`,
  )?.valor;
  const numeroVersao = valores.find(
    item => item.label === `numeroVersao`,
  )?.valor;
  const produtoNome = produtoProposta.nomeProposta;
  const produtoFiname = valores.find(
    item => item.label === `produtoFiname`,
  )?.valor;

  const marca = 'Marca Fockink';
  const areaIrrigada = valores.find(
    item => item.label === `FT_areaTotalIrrigada`,
  )?.valor;

  const raio = valores.find(
    item => item.label === `FT_raioEfetivoAreaIrrigada`,
  )?.valor;

  const dataAtual = valores.find(item => item.label === `dataAtual`)?.valor;

  const sistema = valores.find(
    item => item.label === `FT_sistemaBombeamento`,
  )?.valor;

  const comprimentoTotalTubos = valores.find(
    item => item.label === `FT_comprimentoTotalTubos`,
  )?.valor;

  const raio1 = valores.find(item => item.label === `FT_aspersor1Raio`)?.valor;

  const raio2 = valores.find(item => item.label === `FT_aspersor2Raio`)?.valor;

  const incluirAspersorFinal = valores.find(
    item => item.label === `FT_incluirAspersorFinal`,
  )?.valor;

  const areaEfetivaIrrigadaSAF = valores.find(
    item => item.label === `FT_areaEfetivaIrrigadaSAF`,
  )?.valor;

  const areaTotalIrrigadaCAF = valores.find(
    item => item.label === `FT_areaTotalIrrigadaCAF`,
  )?.valor;

  const quantidadeLances = valores.find(
    item => item.label === `FT_quantidadeLances`,
  )?.valor;

  const prazoInstalacao = valores.find(
    item => item.label === `propostaPrazoInstalacao`,
  )?.valor;

  const clienteIE = valores.find(item => item.label === `clienteIE`)?.valor;

  const clienteDocumento = valores.find(
    item => item.label === `clienteDocumento`,
  )?.valor;

  const clienteEmail = valores.find(
    item => item.label === `clienteEmail`,
  )?.valor;

  const clienteNomeFantasia = valores.find(
    item => item.label === `clienteNomeFantasia`,
  )?.valor;

  const clienteTelefone = valores.find(
    item => item.label === `clienteTelefone`,
  )?.valor;

  const clienteUF = valores.find(item => item.label === `clienteUF`)?.valor;

  const clienteMunicipio = valores.find(
    item => item.label === `clienteMunicipio`,
  )?.valor;

  const clienteEndereco = valores.find(
    item => item.label === `clienteEndereco`,
  )?.valor;

  const clienteEnderecoLatitude = valores.find(
    item => item.label === `clienteEnderecoLatitude`,
  )?.valor;

  const clienteEnderecoLongitude = valores.find(
    item => item.label === `clienteEnderecoLongitude`,
  )?.valor;

  const clienteEnderecoBairro = valores.find(
    item => item.label === `clienteEnderecoBairro`,
  )?.valor;

  const clienteEnderecoCEP = valores.find(
    item => item.label === `clienteEnderecoCEP`,
  )?.valor;

  const propostaEndereco = valores.find(
    item => item.label === `propostaEndereco`,
  )?.valor;

  const propostaUF = valores.find(item => item.label === `propostaUF`)?.valor;

  const propostaMunicipio = valores.find(
    item => item.label === `propostaMunicipio`,
  )?.valor;

  const propostaEnderecoBairro = valores.find(
    item => item.label === `propostaEnderecoBairro`,
  )?.valor;

  const propostaEnderecoCEP = valores.find(
    item => item.label === `propostaEnderecoCEP`,
  )?.valor;

  const propostaValorDadoGeodesico = valores.find(
    item => item.label === `propostaValorDadoGeodesico`,
  )?.valor;

  const propostaInscricaoEstadual = valores.find(
    item => item.label === `propostaInscricaoEstadual`,
  )?.valor;

  const usaAspersorFinal: boolean =
    String(incluirAspersorFinal).toUpperCase() === 'SIM' ||
    String(incluirAspersorFinal).toUpperCase() === 'S';

  const valorArea = usaAspersorFinal
    ? Number(areaTotalIrrigadaCAF ?? 0)
    : Number(areaEfetivaIrrigadaSAF ?? 0);

  const propostaParcelas = valores.find(
    item => item.label === `propostaParcelas`,
  )?.valor;

  const propostaMatrizResponsabilidadeFockink = valores.find(
    item => item.label === `propostaMatrizResponsabilidadeFockink`,
  )?.valor;

  const propostaMatrizResponsabilidadeCliente = valores.find(
    item => item.label === `propostaMatrizResponsabilidadeCliente`,
  )?.valor;

  const papeisAtaOwner = papeisAta.filter(
    campo => campo.codigo === propostaVersao?.proposta.usuario.pessoaDomSGE,
  );

  /*
  Retirado temporariamente por solicitação em comentário da task #2059
  if (
    !propostaEndereco ||
    !propostaUF ||
    !propostaMunicipio ||
    !propostaEnderecoCEP ||
    !propostaInscricaoEstadual
  )
    return (
      <>
        <Row>
          <Col sm="12" className="mt-1">
            <p>
              Para visualização do Pedido de Venda, é necessário ter o endereço
              e Inscrição Estadual preenchidos na aba de <strong>Obra</strong>{' '}
              na proposta.
            </p>
          </Col>
        </Row>
      </>
    ); */

  async function getOrcamento() {
    if (orcamentoId) {
      const response = await api.get(`/orcamento/${orcamentoId}`);
      setOrcamento(response.data);
    }
  }

  async function listaPapeisAta() {
    if (propostaVersao.id) {
      const response = await api.post(
        `/integracao/niveis-indicadores/tipos-indicadores-ata/`,
        {
          propostaVersaoId: propostaVersao.id,
        },
      );

      setPapeisAta(response.data);
    }
  }

  async function buscaAvalista() {
    if (propostaVersao.id) {
      const response = await api.get(
        `/proposta/versao/${propostaVersao.id}/avalista`,
      );

      setAvalista(response.data);
    }
  }

  useEffect(() => {
    listaPapeisAta();
  }, []);

  useEffect(() => {
    getOrcamento();
  }, []);

  useEffect(() => {
    if (propostaVersao.necessitaAvalista) {
      buscaAvalista();
    }
  }, []);

  useEffect(() => {
    if (propostaVersao.necessitaAvalista) {
      buscaAvalista();
    }
  }, [propostaVersao]);

  function renderNewValue() {
    if (meioPagamentoId === 3) {
      // Se for meioPagamento Paralelo, formata melhor a exibição.

      const totalRP =
        propostaParcelas
          ?.filter((item: any) => item.meioPagamentoId === 1)
          ?.reduce((total: any, item: any) => total + item.percentual, 0) ?? 0;

      const financiado = propostaParcelas
        ?.filter((item: any) => item.meioPagamentoId === 2)
        ?.map((item: any) => {
          const dataParcelaPrevista = `${
            String(item.dataPrevista)?.split('T')[0]
          }T21:00:00`;
          return (
            <li key={item.id}>
              <strong>{item.observacao}: </strong>
              {arredondaDecimais(item.percentual)}% do Valor Financiado /{' '}
              {new Date(dataParcelaPrevista).toLocaleDateString()};
            </li>
          );
        });

      return (
        <>
          <ol style={{ color: '#0000FF' }}>
            <li>
              <strong>Entrada (Recurso Próprio):</strong>{' '}
              {arredondaDecimais(totalRP)}% do Preço Total
            </li>
            <li>
              <strong>Financiamento:</strong> {arredondaDecimais(100 - totalRP)}
              % do Preço Total, dividido em:
              <ul>{financiado}</ul>
            </li>
          </ol>
        </>
      );
    }
    return propostaParcelas.map((item: any) => {
      const dataParcelaPrevista = `${
        String(item.dataPrevista)?.split('T')[0]
      }T21:00:00`;
      return (
        <div key={item.id} style={{ color: '#0000FF' }}>
          {arredondaDecimais(item.percentual)}% {formatCurrency(item.valor)}{' '}
          {item.meioPagamento?.descricao} / {item.observacao} /{' '}
          {new Date(dataParcelaPrevista).toLocaleDateString()}
        </div>
      );
    });
  }

  return (
    <>
      <Row>
        <Col sm="12" className="mt-1">
          <div
            style={{
              float: 'left',
              padding: '0px',
            }}
          >
            <img src={LogoImg} alt="Logo" width="50%" height="50%" />
          </div>

          <div
            style={{
              float: 'right',
              fontSize: '12px',
              lineHeight: '1em',
            }}
          >
            <strong>
              FOCKINK INDÚSTRIAS ELÉTRICAS LTDA. <br />
              CNPJ 03.021.334/0001-30 INSCR.EST.090/0013192 <br />
              CNPJ (Matriz) 03.021.334/0001-30
            </strong>
          </div>
        </Col>
      </Row>
      <div
        style={{
          textAlign: 'justify',
          textJustify: 'inter-word',
          padding: '0px',
          lineHeight: '1em',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <h1>Pedido de Venda</h1>
        </div>
        <div>
          <h2>
            PROPOSTA ORÇAMENTARIA Nº: {numeroProposta} v{numeroVersao}
            {listaDadosProdutos.length > 0 && (
              <span>
                {' (Configurações: '}
                {listaDadosProdutos.map(
                  (
                    prod: { configuracao: { orcamentoId: string } },
                    index: number,
                  ) => (
                    <span key={index}>
                      {prod.configuracao.orcamentoId}
                      {index < listaDadosProdutos.length - 1 ? ', ' : ''}
                    </span>
                  ),
                )}
                )
              </span>
            )}
          </h2>
        </div>
        <div>Data Emissão: {dataAtual}</div>
        {/* <div>
          Gestor/Representante/Gerente:{' '}
          {propostaVersao?.proposta?.usuario?.nome} / {orcamento?.representante}
        </div> */}
        {/* <div>
          Gestor/Representante/Gerente:{' '}
          {PapeisAtaOwner.length > 0
            ? PapeisAtaOwner.map(campo => campo.pessoa).join(' / ')
            : propostaVersao?.proposta?.usuario?.nome}{' '}
          / {orcamento?.representante}
        </div> */}
        <div>
          Gestor/Representante/Gerente:{' '}
          {papeisAtaOwner.length > 0
            ? papeisAtaOwner.map(campo => campo.pessoa)
            : propostaVersao?.proposta?.usuario?.nome}{' '}
          / {orcamento?.representante}
        </div>
        <br />
        <div>
          <strong>Cliente: </strong>
          {clienteNome}
        </div>
        <div>
          <strong>Fazenda: </strong>
          {clienteNomeFantasia ?? ''}
        </div>
        <div>End. Entrega: {propostaEndereco}</div>
        <Row>
          <Col sm="6">Cidade: {propostaMunicipio}</Col>
          <Col sm="2">UF: {propostaUF}</Col>
          <Col sm="2">CEP: {propostaEnderecoCEP}</Col>
        </Row>
        <Row>
          <Col sm="6">CNPJ/CPF: {clienteDocumento}</Col>
          <Col sm="6">IE/IP: {propostaInscricaoEstadual}</Col>
        </Row>
        <Row>
          <Col sm="6">End. Cobrança: {clienteEndereco}</Col>
          <Col sm="6">Bairro: {clienteEnderecoBairro}</Col>
        </Row>
        <Row>
          <Col sm="6">Cidade: {clienteMunicipio}</Col>
          <Col sm="2">UF: {clienteUF}</Col>
          <Col sm="2">CEP: {clienteEnderecoCEP}</Col>
        </Row>
        <div>Tel | Cel: {clienteTelefone}</div>
        <div>Responsável e-mail: {clienteEmail}</div>
        <div>Coordenadas Geográficas:{` ${propostaValorDadoGeodesico}`}</div>

        {/* <div>
          <h2>Produto: </h2>
        </div>
        <div style={{ color: '#0000FF' }}>
          01 {produtoNome}, {marca}, sistema {sistema} com {quantidadeLances}{' '}
          torres de sustentação, raio{' '}
          {Number(comprimentoTotalTubos ?? 0) + (raio1 > raio2 ? raio1 : raio2)}{' '}
          M para área irrigada de {valorArea} HA.
        </div>
        <div>
          <strong>COD.FINAME: {`${produtoFiname} ${produtoNome}`}</strong>
        </div>
        <div>Tensão: {tensao ?? 0} Volts </div> */}

        <div>
          <h2>Produto(s): </h2>
        </div>

        {listaDadosProdutos.length > 0
          ? listaDadosProdutos.map(
              (
                prod: {
                  produto: any;
                  fichaTecnica: {
                    tensaoTrifasica: number;
                    FichaTecnicaBombeamento: { motor: any }[];
                    FichaTecnicaLance: any[];
                    comprimentoTotalTubos: any;
                    aspersor1Raio: number;
                    aspersor2Raio: number;
                    incluirAspersorFinal: any;
                    areaTotalIrrigadaCAF: any;
                    areaEfetivaIrrigadaSAF: any;
                  };
                },
                index: number,
              ) => (
                <div key={index}>
                  <div style={{ color: '#0000FF' }}>
                    01{' '}
                    {prod.produto[0].nomeProposta ??
                      prod.produto[0].nome ??
                      'NÃO INFORMADO'}
                    {prod.produto[0].id === 1 || prod.produto[0].id === 8 ? (
                      <>
                        , {marca}, sistema{' '}
                        {prod?.fichaTecnica.FichaTecnicaBombeamento?.[0]
                          ?.motor || 'NÃO INFORMADO'}{' '}
                        com{' '}
                        {prod.fichaTecnica.FichaTecnicaLance?.reduce(
                          (total: any, item: any) => total + item.quantidade,
                          0,
                        ) || 'NÃO INFORMADO'}{' '}
                        torres de sustentação, raio{' '}
                        {Number(prod.fichaTecnica.comprimentoTotalTubos ?? 0) +
                          (prod.fichaTecnica.aspersor1Raio >
                          prod.fichaTecnica.aspersor2Raio
                            ? prod.fichaTecnica.aspersor1Raio
                            : prod.fichaTecnica.aspersor2Raio) ||
                          'NÃO INFORMADO'}{' '}
                        M para área irrigada de{' '}
                        {String(
                          prod.fichaTecnica.incluirAspersorFinal,
                        ).toUpperCase() === 'SIM' ||
                        String(
                          prod.fichaTecnica.incluirAspersorFinal,
                        ).toUpperCase() === 'S'
                          ? Number(prod.fichaTecnica.areaTotalIrrigadaCAF ?? 0)
                          : Number(
                              prod.fichaTecnica.areaEfetivaIrrigadaSAF ?? 0,
                            ) || 'NÃO INFORMADO'}{' '}
                        HA.
                        <br />
                      </>
                    ) : null}
                  </div>
                  {prod.produto[0].id === 1 || prod.produto[0].id === 8 ? ( // Mover o COD.FINAME para fora do estilo
                    <div>
                      <strong>
                        COD.FINAME:{' '}
                        {`${prod.produto[0].finame || 'NÃO INFORMADO'} ${
                          prod.produto[0].nomeProposta ??
                          prod.produto[0].nome ??
                          'NÃO INFORMADO'
                        }`}
                        <div>
                          Tensão:{' '}
                          {prod.fichaTecnica.tensaoTrifasica ?? 'NÃO INFORMADO'}{' '}
                          Volts{' '}
                        </div>
                      </strong>
                    </div>
                  ) : null}

                  <br />
                </div>
              ),
            )
          : ''}

        <div>
          <h2>Condições Específicas de Fornecimento: </h2>
        </div>
        <div>
          <strong>Fockink fornece: </strong>
          {propostaMatrizResponsabilidadeFockink}
        </div>
        <div>
          <strong>Cliente fornece: </strong>
          {propostaMatrizResponsabilidadeCliente}
        </div>
        <div>
          <strong>Diferencial de ICMS por conta do Comprador.</strong>
        </div>
        <div>Prazo de Instalação: {prazoInstalacao}</div>
        <div>
          <strong>Preço: R$ {propostaValorFinal}</strong>{' '}
          <i>({propostaValorFinalExtenso} reais)</i>
        </div>
        <div>
          <strong>Obs: </strong>Prazo vinculado ao fornecimento de dados para
          projeto definitivo, obras de infra estrutura e condições de montagem
          disponíveis conforme proposta comercial e Condições Gerais de
          Fornecimento.
        </div>
        <div>
          <strong>Condições de Pagamento: </strong>
        </div>
        {/* {propostaParcelas.map((item: any) => (
          <div style={{ color: '#0000FF' }}>
            {item.percentual}% {formatCurrency(item.valor)}{' '}
            {item.meioPagamento?.descricao} / {item.observacao} /{' '}
            {String(item.dataPrevista)?.split('T')[0]}
          </div>
        ))} */}
        {renderNewValue()}
        <br />
        <div>
          O cliente declara ter ciência e concordar que os valores avençados no
          presente serão realizados por intermediário de Depósito/Transferência
          bancária (Banco do Brasil - 001, Agência 0709-9, Conta Corrente
          2831-2), Pix (CNPJ) 03.021.334/0001-30, nas datas especificadas neste
          instrumento.
        </div>
        <br />
        <div>
          O atraso no pagamento de quaisquer das parcelas acima referidas,
          acarretará ao Comprador(a) a obrigação de pagar o valor atualizado,
          que poderá ser reajustado com base nos índices IPCA ou IGP-M, conforme
          critério exclusivo da Vendedora, acrescido de juros de mora de 2% ao
          mês, despesas de cobrança no percentual de 1%, além de multa de 10%
          sobre o valor total da venda. Em caso de inadimplemento, a Vendedora
          fica expressamente autorizada a encaminhar o título vencido ao
          Cartório de Protestos e a proceder com a inclusão do nome do
          Comprador(a) em cadastros de inadimplentes ou serviços legalmente
          constituídos para proteção ao crédito, tais como SPC e SERASA.
          Ademais, o não pagamento de qualquer parcela poderá, a critério
          exclusivo da Vendedora, ensejar o vencimento antecipado do saldo
          devedor, tornando-se exigível o pagamento imediato de toda a dívida.
        </div>
        <div>
          Em caso, paralelamente a esta transação definida neste pedido, o
          COMPRADOR venha a buscar um financiamento junto ao Sistema Financeiro
          Nacional - linhas de crédito e financiamentos, a VENDEDORA poderá
          aguardar o recebimento do respectivo financiamento/autorização de
          faturamento por um prazo máximo de até 120 (cento e vinte) dias.
          Quando da liberação dos fundos para a VENDEDORA, pela respectiva
          instituição financeira escolhida pelo COMPRADOR, será efetuado um
          encontro de contas entre o valor já pago e valor liberado, devendo ser
          devolvido ao COMPRADOR, se for o caso, o valor excedente ao montante
          total do pedido. Na eventual ocorrência do evento de refaturamento
          e/ou de financiamento do equipamento, mesmo sem o refaturamento, o
          COMPRADOR deste já concorda com a cobrança de eventuais despesas
          administrativas decorrentes da transação de até 4,5% do valor total do
          pedido, que será apresentado pela VENDEDORA, através de nota de débito
          os valores decorrentes da transação financeira, que será descontado do
          saldo a ser devolvido ao COMPRADOR, se for, e conforme cada caso.
          Sendo este financiamento bancário aprovado, e a instituição financeira
          efetuando a liberação de ou dos os valores desta ou das operações
          diretamente ao COMPRADOR, este se obriga a realizar o pagamento
          integral das parcelas faltantes a VENDEDORA, independentemente das
          condições de pagamento descrita no pedido.
        </div>
        <div>
          Caso a montagem e entrega do sistema de irrigação seja postergada por
          solicitação do Comprador ou pelo atraso no cumprimento das obrigações
          de sua responsabilidade (conforme matriz de responsabilidades), fica
          acordado que o pagamento correspondente a 80% da parcela prevista para
          quitação após a montagem deverá ser efetuado na data originalmente
          prevista para tal pagamento, independentemente da efetiva conclusão
          e/ou entrega do sistema de irrigação. O saldo remanescente de 20%
          poderá ser pago após a conclusão efetiva da montagem, acrescido de
          correção pelo IGPM (se positivo), acrescido de juros de 1% ao mês,
          calculada pro rata die, desde a data originalmente prevista para o
          pagamento até a data do pagamento efetivo.
        </div>
        <div>
          O presente pedido é celebrado em caráter irrevogável, irretratável e
          irreversível obrigando o COMPRADOR e seus legítimos sucessores a
          qualquer título a cumpri-lo segundo as bases contratadas. Eventual
          desistência do COMPRADOR implica no pagamento de multa compensatória
          desde já fixada em 20% (vinte por cento) sobre o valor total do
          pedido, devendo efetuar o pagamento pelos serviços já executados e
          materiais adquiridos para o processo de industrialização, sem prejuízo
          dos termos constantes nas Condições Gerais de Fornecimento.
        </div>
        <br />
        <div>
          <strong>Efeito de alteração de impostos: </strong>
        </div>
        <div>
          Os preços ofertados consideram as aliquotas, benefícios e incentivos
          fiscais previstos na legislação tributária vigente neste momento,
          assim sendo, quaisquer tributos, aumento de impostos, taxas,
          contribuições fiscais ou parafiscais ou outros encargos legais
          criados, alterados ou extintos, bem como a superveniência de
          disposições legais, quando ocorridas após a data da apresentação da
          proposta e pedido, de comprovada repercussão nos preços contratados,
          implicarão a revisão destes, ficando estipulado que o pagamento das
          diferenças apuradas deverão ser adimplidas junto a última parcela.
        </div>
        <br />
        <div>
          <strong>Observações: </strong>
        </div>
        <div>
          O presente pedido de venda será regido pelas cláusulas constantes nas
          Condições Gerais de Fornecimento que é parte integrante deste pedido
          na forma de anexo, sendo que o Comprador declara neste ato estar
          ciente e de acorco com seus termos e condições, reconhece que o
          presente pedido de venda, assim como o documento Condições Gerais de
          Fornecimento possuem força de título executivo extrajudicial, nos
          termos do Código de Processo Civil. O Comprador declara ainda estar
          ciente e concorda com as obrigações ajustadas pelas Partes na matriz
          de responsabilidades.
        </div>
        <br />
        <div>
          <strong>Aceite do Pedido: </strong>
        </div>
        <div>
          O Cliente Declara ter lido e estar de acordo com as Condições Gerais
          de Fornecimento, proposta comercial e matriz de responsabilidades, que
          são parte integrantes deste pedido.
        </div>
        <br />
        <Row>
          <Col sm={propostaVersao?.necessitaAvalista ? 3 : 4}>
            <div
              style={{
                textAlign: 'center',
                verticalAlign: 'top',
                marginTop: '100px',
              }}
            >
              ______________________ <br />
              Cliente
            </div>
          </Col>
          <Col sm={propostaVersao?.necessitaAvalista ? 3 : 4}>
            <div
              style={{
                textAlign: 'center',
                verticalAlign: 'top',
                marginTop: '100px',
              }}
            >
              ______________________ <br /> Testemunha 1 <br />
            </div>
          </Col>
          <Col sm={propostaVersao?.necessitaAvalista ? 3 : 4}>
            <div
              style={{
                textAlign: 'center',
                verticalAlign: 'top',
                marginTop: '100px',
              }}
            >
              ______________________ <br />
              Testemunha 2 <br />
            </div>
          </Col>
          {propostaVersao?.necessitaAvalista && (
            <Col sm="3">
              <div
                style={{
                  textAlign: 'center',
                  verticalAlign: 'top',
                  marginTop: '100px',
                }}
              >
                ______________________ <br />
                {avalista?.nomeAvalista || 'Avalista'} <br />
                {formataCnpjCpf(avalista?.documentoAvalista)} <br />
              </div>
            </Col>
          )}
        </Row>
      </div>
    </>
  );
}
